export const DYNAMIC_PARTS_NAME = {
  TABLE_OF_CONTENTS: 'table_of_contents',
  HEADLINE: 'headline',
};
